export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fe201a26bac23f608d67deb3b926c9e41a5e3f3ef&name=fetchTypeahead!'